import LocalStorage from "../localStorage";

const retrieveBookmarks = () => {
  const localStorageBookmarks = LocalStorage.getBookmarks();

  return localStorageBookmarks
    ? localStorageBookmarks
    : [0, 1, null, null];
};

export default retrieveBookmarks;
